import './App.css';
import React from 'react';  
import { useEffect, useMemo, useRef, useState } from "react";
import {Routes, Route, BrowserRouter} from 'react-router-dom'
import Index from './Index/index'
import About from './About/About'
import Posts from './Posts/Posts';
import News from './NewsPosts/News';
import Gallery from './Galery/Galery';
import ContactUS from './ContactUs/ContactUs';
import Chat from './Chat/Chat';
import ColleagueChat from './ColleagueChat/ColleagueChat';
import StudentChat from './StudentChat/StudentChat';
import EmptyPge from './errors/emptyPage/emptyPge';

const App = () => {
  return (
      <>
      <BrowserRouter>
          <Routes>
              <Route path='/' element={<Index />} />
              <Route path='/about' element={<About />} />
              <Route path='/posts' element={<Posts />} />
              <Route path='/news' element={<News />} />
              <Route path='/galery' element={<Gallery />} />
              <Route path='/contactUs' element={<ContactUS />} />
              <Route path='/colleagueChat' element={<ColleagueChat />} />
              <Route path='/studentChat' element={<StudentChat />} />
              <Route path='*' element={<EmptyPge />} />
          </Routes>
      </BrowserRouter>
      </>
  )
}

export default App;
